// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PzNkF{position:relative;width:85%}.PzNkF .eefSA{height:48px}.PzNkF .KQx0a{position:absolute;inset:0;display:flex;align-items:center;justify-content:flex-start;pointer-events:none;font-family:"Lufga-Regular";font-weight:400;font-size:14px;padding-left:16px;letter-spacing:.00938em;white-space:nowrap;gap:4px}.PzNkF .m4B28{visibility:hidden}.PzNkF .AE9Lf{pointer-events:auto;color:#000;display:inline-flex}.PzNkF .IpAHN{display:flex;min-width:0}.PzNkF .v7YUW{pointer-events:auto;display:inline-flex}.PzNkF:focus-within .KQx0a{display:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontFamilyLight": `"Lufga-Regular"`,
	"fontFamilyNormal": `"Lufga-Medium"`,
	"fontFamilyBold": `"Lufga-SemiBold"`,
	"fontSizeH1": `var(--font-size-h1, 40px)`,
	"fontSizeH2": `var(--font-size-h2, 36px)`,
	"fontSizeH3": `var(--font-size-h3, 28px)`,
	"fontSizeH4": `var(--font-size-h4, 24px)`,
	"fontSizeH5": `var(--font-size-h5, 20px)`,
	"fontSizeH6": `var(--font-size-h6, 18px)`,
	"fontSizeP1": `var(--font-size-p1, 14px)`,
	"fontSizeP2": `var(--font-size-p2, 12px)`,
	"fontSizeP3": `var(--font-size-p3, 10px)`,
	"lineHeightH1": `var(--line-height-h1, 56px)`,
	"lineHeightH2": `var(--line-height-h2, 52px)`,
	"lineHeightH3": `var(--line-height-h3, 36px)`,
	"lineHeightH4": `var(--line-height-h4, 34px)`,
	"lineHeightH5": `var(--line-height-h5, 32px)`,
	"lineHeightH6": `var(--line-height-h6, 30px)`,
	"lineHeightP1": `var(--line-height-p1, 22px)`,
	"lineHeightP2": `var(--line-height-p2, 16px)`,
	"lineHeightP3": `var(--line-height-p3, 14px)`,
	"LegalTermsDropdown": `PzNkF`,
	"LegalTermsDropdownInput": `eefSA`,
	"anchorDefaultOverlay": `KQx0a`,
	"anchorDefaultMeasureText": `m4B28`,
	"anchorDefaultInfoIcon": `AE9Lf`,
	"itemDetailsTooltipTrigger": `IpAHN`,
	"anchorDefaultBadge": `v7YUW`
};
export default ___CSS_LOADER_EXPORT___;
